import React from "react";
import { Box, AppBar, Toolbar, Typography } from "@mui/material";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../consts/colors";

export const MobileTopBar = () => {
  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: PRIMARY_COLOR,
          color: SECONDARY_COLOR,
          height: "64px",
        }}
      >
        <Toolbar sx={{ heieght: "64px" }}>
          <Typography
            variant="h4"
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              fontFamily: "Tenor Sans",
            }}
          >
            NIRAN
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ height: "64px" }} />
    </Box>
  );
};
